import { createActionGroup, emptyProps, props } from "@ngrx/store";

import { PandadocArtifactFragment } from "../../../generated/graphql.generated";
import { ActionSource } from "../../state/action-sources";

export const JobEstimateActions = createActionGroup({
  source: ActionSource.JOB_ESTIMATE,
  events: {
    'Document Clicked': props<{ artifactId: string }>(),
    'Send Document Button Clicked': props<{ artifactId: string }>(),
    'Open Document Actions Button Clicked': props<{ artifactId: string }>(),
    'View Document Menu Item Clicked': emptyProps(),
    'Download Document Menu Item Clicked': emptyProps(),
    'Delete Document Menu Item Clicked': emptyProps(),
    'View As Employee Menu Item Clicked': emptyProps(),
    'View As Customer Menu Item Clicked': emptyProps(),
    'Print Menu Item Clicked': emptyProps(),
    'Open In Right Panel Menu Item Clicked': emptyProps(),
    'Refresh Menu item Clicked': emptyProps(),
    'Attach To Bol Menu Item Clicked': emptyProps(),
    'Detach From Bol Menu Item Clicked': emptyProps(),
    'Send Document Success': props<{
      jobId: string;
      artifactId: string;
    }>(),
    'Send Document Error': props<{
      error: Error;
      artifactId: string;
    }>(),
    'Delete Document Success': props<{
      artifactId: string;
      jobId: string;
    }>(),
    'Delete Document Error': props<{
      error: Error;
    }>(),
    'Refresh Document Success': props<{
      jobId: string;
      artifact: PandadocArtifactFragment;
    }>(),
    'Refresh Document Error': props<{
      error: Error;
    }>(),
  },
});
